import BApp from "../../modules/BApp";
import BConfig from "../../modules/BConfig";
import BForm from "../../modules/BForm";
import BRequest from "../../modules/BRequest";

export default class BHealthcareProviderSetupForm extends BForm
{
	static className = () => `b-healthcare-provider-setup-form`;
	static selector = () => `.${this.className()}`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", event => {
			if (event.target.matches(`${this.selector()} input`)) {
				const form = (new this(event.target.closest(this.selector())));
				form.resetHealthcareProvider();
				form.search();
			}
		});

		document.addEventListener("click", event => {
			const selector = `.${this.className()}__select-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const form = (new this(event.target.closest(this.selector())));
				form.resetResults();
				form.setPersonWorkplace(event.target.closest(`[data-payload]`).dataset.payload);
			}
		});
	}

	search()
	{
		this.resetResults();

		const data = {
			name: this.el.querySelector(`[name="healthcareProvider_name"]`).value,
			street: this.el.querySelector(`[name="healthcareProvider_street"]`).value,
			city: this.el.querySelector(`[name="healthcareProvider_city"]`).value,
			postalCode: this.el.querySelector(`[name="healthcareProvider_postalCode"]`).value,
			page: 1,
			perPage: 10,
		};

		if (data.name.length >= 2 || data.city.length >= 2) {
			BRequest.get(BConfig.getRoute("api.v2.healthcare.personWorkplaces"), data).then(response => {
				this.resetResults().setResults(response.data);
			});
		}
	}

	getResultsElement()
	{
		return this.el.querySelector(`${BHealthcareProviderSetupForm.selector()}__results`);
	}

	resetResults()
	{
		this.getResultsElement().querySelector(`tbody`).innerHTML = null;
		this.getResultsElement().hidden = true;

		return this;
	}

	setResults(results)
	{
		Array.from(results).forEach(result => {
			this.getResultsElement().querySelector(`tbody`).append(BApp.createElement(`
			<tr data-payload='${JSON.stringify(result)}'>
				<td>
					<p>${result.person.title}</p>
				</td>
				<td>
					<p>${result.workplace.address.street}, ${result.workplace.address.city}</p>
				</td>
				<td><button class="jp-button jp-button--outline-primary jp-button--md ${BHealthcareProviderSetupForm.className()}__select-button" type="button">Vybrat</button></td>
			</tr>`, `tbody`));
			this.getResultsElement().hidden = false;
		});

		return this;
	}

	setPersonWorkplace(payload)
	{
		const personWorkplace = JSON.parse(payload);
		this.el.querySelector(`[name="healthcarePerson_reference"]`).value = personWorkplace.person.reference;
		this.el.querySelector(`[name="healthcareProvider_name"]`).value = personWorkplace.person.title;
		this.el.querySelector(`[name="healthcareProvider_street"]`).value = personWorkplace.workplace.address.street;
		this.el.querySelector(`[name="healthcareProvider_city"]`).value = personWorkplace.workplace.address.city;
		this.el.querySelector(`[name="healthcareProvider_postalCode"]`).value = personWorkplace.workplace.address.postalCode;

		return this;
	}

	resetHealthcareProvider()
	{
		this.el.querySelector(`[name="healthcarePerson_reference"]`).value = null;
		this.el.querySelector(`[name="healthcareProvider_ico"]`).value = null;

		return this;
	}
}
